import type { RootState } from "../store";

/**
 * The group a room-family booking (apartment / venue, BookingFlowShell) is
 * made for — the ONE answer both creation flows use:
 * `createReservationFlow` (direct booking, opted in by the shell) and
 * `createVenueReservationFlow` (request order).
 *
 * The selected room's own `groupId` comes FIRST. It is written synchronously
 * when the customer picks the room (`setSelectedApartment`, selection step and
 * URL hydration). `bookingCreation.assetGroupId` is only rewritten once the
 * picked room's details have loaded (`useEnsureApartmentDetails`), so until
 * then it still names the room viewed BEFORE: room A → back → pick room B →
 * click through before B's details land, and A would be booked.
 *
 * `assetGroupId` remains the fallback for a state without a selected room.
 * Not for the station flows: there `assetGroupId` is the only source, and a
 * `selectedApartment` left over from a room flow must never be booked.
 */
export const selectRoomFamilyGroupId = (state: RootState): string | null =>
  state.apartment.selectedApartment?.groupId ||
  state.bookingCreation.assetGroupId ||
  null;
